import React from "react";
import { ExternalLink, CheckCircle2, AlertCircle } from "lucide-react";
import { SOCIAL_PLATFORMS, SocialGlyph, validSocialUrl } from "@/components/layout/SocialIcons";

export default function SocialSettings({ s, setS }) {
    return (
        <div className="lnl-card p-5" data-testid="social-settings">
            <div className="lnl-eyebrow">Social media</div>
            <p className="text-xs text-lnl-gray mt-1">Use only LNL's official profile links. Icons appear in the footer and Contact page when a valid https link is saved and the platform is turned on.</p>
            <div className="mt-4 divide-y divide-lnl-border">
                {SOCIAL_PLATFORMS.map((p) => {
                    const url = s[p.key] || "";
                    const on = s[`${p.key}_enabled`] !== false;
                    const ok = url && validSocialUrl(url, p.domains);
                    return (
                        <div key={p.k} className="py-3 grid grid-cols-1 md:grid-cols-[180px_1fr_auto] gap-3 md:items-center" data-testid={`social-row-${p.k}`}>
                            <div className="flex items-center gap-2 font-heading font-semibold text-sm text-lnl-charcoal">
                                <span className="w-8 h-8 grid place-items-center rounded-md bg-lnl-off-white border border-lnl-border"><SocialGlyph k={p.k} /></span>{p.label}
                            </div>
                            <div>
                                <input value={url} onChange={(e) => setS({ ...s, [p.key]: e.target.value })} placeholder={`https://${p.domains[0]}/…`}
                                    className={`w-full rounded-md border px-3 py-2 text-sm ${url && !ok ? "border-rose-400" : "border-lnl-border"}`} data-testid={`settings-${p.key}`} />
                                <div className="mt-1 text-[11px] flex items-center gap-1.5">
                                    {!url && <span className="text-lnl-gray">Not configured — icon hidden.</span>}
                                    {url && !ok && <span className="text-rose-700 flex items-center gap-1" data-testid={`social-error-${p.k}`}><AlertCircle className="h-3 w-3" /> Must be an https:// link on {p.domains.join(" or ")}.</span>}
                                    {ok && <><CheckCircle2 className="h-3 w-3 text-emerald-600" /><a href={url} target="_blank" rel="noopener noreferrer" className="text-lnl-green-deep hover:underline inline-flex items-center gap-1" data-testid={`social-preview-${p.k}`}>Preview link <ExternalLink className="h-3 w-3" /></a></>}
                                </div>
                            </div>
                            <label className="flex items-center gap-2 text-xs font-heading font-semibold">
                                <input type="checkbox" checked={on} onChange={(e) => setS({ ...s, [`${p.key}_enabled`]: e.target.checked })} data-testid={`settings-${p.key}_enabled`} />
                                Show icon
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
